module.exports = __webpack_public_path__ + "img/MoFoto2.e34891f8.jpg";